import { Component, OnInit } from '@angular/core';
import {AppState, selectAuthState, selectPatientState} from '../../../store/app.states';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {Pending} from '../../../model/questionnaires/Pending';
import {Router} from '@angular/router';
import {GetPendings} from '../../../store/actions/patient.actions';
import * as _moment from 'moment';
import { PatientService } from 'src/app/services/patient.service';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.css']
  })

  export class FaqComponent implements OnInit{

    title = 'FAQ';
    user = null;
    back = true;
    destination = '/landing';
    getAuthState: Observable<any>;
    getPatientState: Observable<any>;
    faq = [{domanda:"Ho dimenticato la password, cosa posso fare?",
            risposta:"Se hai dimenticato la password, potrai recuperarla cliccando sul link “Non ricordi come accedere?” della pagina principale. Attraverso la mail ed il codice fiscale, potrai resettare la password cliccando nel link che riceverai per email."},
            {domanda:"Come posso comunicare con i medici?",
            risposta:"Puoi comunicare con il tuo medico attraverso la nostra chat. Puoi accedere alla chat cliccando sull'apposita icona ( in alto a destra, accanto al nome - cognome ) oppure attraverso la sezione “Interagisci con il medico” della pagina principale"},
            {domanda:"Come posso visualizzare eventuali avvisi/news?",
            risposta:"Puoi visualizzare eventuali avvisi/news dei medici direttamente dalla tua homepage, in cui verrà mostrato l’avviso più recente. Per gli avvisi più vecchi, potrai accedervi attraverso l’apposita sezione presente nella pagina principale.\nN.B: La sezione per gli avvisi\news è disponibile , per il momento, solamente per una parte dei pazienti. Se non visualizza questa sezione, tutti gli eventuali avvisi\news ti saranno comunicati personalmente attraverso l’email."},
            {domanda:"Come faccio a vedere e compilare i questionari in sospeso?",
            risposta:"Tutti i questionari da compilare ti verranno notificati via email. Per vedere la lista dei questionari in sospeso nella tua pagina personale, ed eventualmente compilarli, ti basterà premere nella sezione “Rispondi ai questionari mandati dal medico” nella homepage, dove sarà presente la lista di tutti i questionari in sospeso"},
            {domanda:"Ogni quanto bisogna compilare i questionari?",
            risposta:"I questionari HBI, SCCAI - IBD-DISK , MIAH-CD, MIAH-UC sono, generalmente, mensili o trimestrali. Gli altri sono trimestrali ad eccezione di PSQI ed EQ5D5L che sono somministrati ogni 6 mesi. In base alla situazione personale, il tempo di somministrazione dei questionari potrà essere modificato dal medico. Ogni qual volta ci sarà un nuovo questionario da compilare, riceverai una mail. Ad ogni modo, puoi inviare un questionario in ogni momento attraverso la sezione “Interagisci con il medico” -> “ Manda un nuovo questionario”."},
            {domanda:"I questionari arretrati andrebbero compilati in base a come si stava in quel periodo o nel periodo di compilazione?",
            risposta:"Ogni nuovo questionario da compilare è notificato attraverso un’email. E’ consigliato di compilarlo regolarmente per poter rispondere alle domande in base allo stato di salute di quel periodo. Nel caso sia passato molto tempo oppure in caso di situazioni particolari/necessità, è’ comunque sempre possibile inviare, autonomamente, dei questionari sulla condizione attuale attraverso la sezione “Interagisci con il medico” -> “ Manda un nuovo questionario”"},
            {domanda:"Posso vedere se il medico ha letto uno dei miei questionari compilati? ",
            risposta:"Si, cliccando nella sezione “Visualizza i questionari già compilati”.\nPer ogni questionario compilato, potrai vedere la data di somministrazione, le risposte date ad ogni domanda e lo stato del questionario "},
            {domanda:"Non hai risolto i tuoi problemi?",
            risposta:"Contatta un medico o scrivi alla seguente mail: ibd.app.mauriziano@gmail.com"}
];

    panelOpenState = false;

    constructor(private store: Store<AppState>,
        private patientService: PatientService,
                  private router: Router) {
        this.getAuthState = this.store.select(selectAuthState);
        this.getPatientState = this.store.select(selectPatientState);
                  }
    ngOnInit(): void {
        this.getAuthState.subscribe((state) => {
            if (state.isAuthenticated) {
            this.user = JSON.parse(localStorage.getItem('user'));
          }
        });
    }

}